module.exports = __webpack_public_path__ + "img/toolarge.06af8a02.png";